/** @module Enums */ /** typedoc */
/**
 * This Enum is valid only for the Distribution APIv1 (AKA. the legacy app):
 * The Distribution MFE will have his own enum for the Distribution APIv2
 * e.g of some changes:
 * GooglePlay => YouTubeMusic
 * ITunes => AppleMusic
 *
 */
var ReleaseStoreEnum;
(function (ReleaseStoreEnum) {
    ReleaseStoreEnum["Amazon"] = "Amazon";
    ReleaseStoreEnum["Beatport"] = "Beatport";
    ReleaseStoreEnum["Deezer"] = "Deezer";
    ReleaseStoreEnum["FacebookInstagram"] = "FacebookInstagram";
    ReleaseStoreEnum["GooglePlay"] = "GooglePlay";
    ReleaseStoreEnum["IHeartRadio"] = "IHeartRadio";
    ReleaseStoreEnum["ITunes"] = "ITunes";
    ReleaseStoreEnum["Other"] = "Other";
    ReleaseStoreEnum["Pandora"] = "Pandora";
    ReleaseStoreEnum["Recognition"] = "Recognition";
    ReleaseStoreEnum["Spotify"] = "Spotify";
    ReleaseStoreEnum["Tidal"] = "Tidal";
    ReleaseStoreEnum["TikTok"] = "TikTok";
    ReleaseStoreEnum["YouTube"] = "YouTube";
    ReleaseStoreEnum["YouTubeMusic"] = "YouTubeMusic";
})(ReleaseStoreEnum || (ReleaseStoreEnum = {}));
var ReleaseStoreLabelEnum;
(function (ReleaseStoreLabelEnum) {
    ReleaseStoreLabelEnum["Amazon"] = "Amazon";
    ReleaseStoreLabelEnum["Beatport"] = "Beatport";
    ReleaseStoreLabelEnum["Deezer"] = "Deezer";
    ReleaseStoreLabelEnum["FacebookInstagram"] = "Facebook & Instagram";
    ReleaseStoreLabelEnum["GooglePlay"] = "Google Play & YouTube Music";
    ReleaseStoreLabelEnum["IHeartRadio"] = "iHeartRadio";
    ReleaseStoreLabelEnum["ITunes"] = "iTunes";
    ReleaseStoreLabelEnum["Other"] = "Other";
    ReleaseStoreLabelEnum["Pandora"] = "Pandora";
    ReleaseStoreLabelEnum["Recognition"] = "Recognition";
    ReleaseStoreLabelEnum["Spotify"] = "Spotify";
    ReleaseStoreLabelEnum["Tidal"] = "Tidal";
    ReleaseStoreLabelEnum["TikTok"] = "TikTok";
    ReleaseStoreLabelEnum["YouTube"] = "YouTube";
    ReleaseStoreLabelEnum["YouTubeMusic"] = "YouTube Music";
})(ReleaseStoreLabelEnum || (ReleaseStoreLabelEnum = {}));

export { ReleaseStoreEnum, ReleaseStoreLabelEnum };
